import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProjectExecutionState {
  isRunning: boolean;
  isPlaywrightMode: boolean;
  consoleOutput: string;
  status: "idle" | "running" | "success" | "failed";
  error: string | null;
}

const initialState: ProjectExecutionState = {
  isRunning: false,
  isPlaywrightMode: false,
  consoleOutput: "",
  status: "idle",
  error: null,
};

const projectExecutionSlice = createSlice({
  name: "projectExecution",
  initialState,
  reducers: {
    setIsRunning(state, action: PayloadAction<boolean>) {
      state.isRunning = action.payload;
    },
    setIsPlaywrightMode(state, action: PayloadAction<boolean>) {
      state.isPlaywrightMode = action.payload;
    },
    appendConsoleOutput(state, action: PayloadAction<string>) {
      state.consoleOutput += action.payload;
    },
    clearConsoleOutput(state) {
      state.consoleOutput = "";
    },
    setStatus(state, action: PayloadAction<"idle" | "running" | "success" | "failed">) {
      state.status = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    resetExecutionState(state) {
      state.isRunning = false;
      state.isPlaywrightMode = false;
      state.consoleOutput = "";
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  setIsRunning,
  setIsPlaywrightMode,
  appendConsoleOutput,
  clearConsoleOutput,
  setStatus,
  setError,
  resetExecutionState,
} = projectExecutionSlice.actions;

export default projectExecutionSlice.reducer;
